import Field from '../Field'
import toString from 'lodash/toString'

export default class extends Field {
  static name = 'string'

  mutator (value) {
    if (typeof value !== 'undefined' && value !== null) {
      value = toString(value)
    }

    return value
  }
}
